import { Directive, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BaseModalDirective implements OnInit, OnDestroy {
  public pending: boolean;
  public dataLoaded: boolean;

  protected readonly subscriptions = new Subscription();

  constructor(protected readonly bsModalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.init();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }

  protected init(): void {}
}
